<button
  *ngIf="button.url"
  nz-button
  [nzType]="button.type || 'primary'"
  [nzDanger]="button.danger || false"
  [nzGhost]="button.ghost || false"
  [nzSize]="button.size || ''"
  [nzShape]="button.shape || ''"
  [nzGhost]="button.ghost || false"
  [disabled]="disabled"
  [routerLink]="button.url ? [button.url] : []"
  (click)="button.url ? null : btnClick($event, button.value)"
>
  <ng-container
    *ngTemplateOutlet="innerBtnTemplate; context: { button: button }"
  >
  </ng-container>
</button>

<button
  *ngIf="!button.url"
  nz-button
  [nzType]="button.type || 'primary'"
  [nzDanger]="button.danger || false"
  [nzGhost]="button.ghost || false"
  [nzSize]="button.size || ''"
  [nzShape]="button.shape || ''"
  [nzGhost]="button.ghost || false"
  [disabled]="disabled"
  (click)="button.url ? null : btnClick($event, button.value)"
>
  <ng-container
    *ngTemplateOutlet="innerBtnTemplate; context: { button: button }"
  >
  </ng-container>
</button>

<ng-template #innerBtnTemplate let-button="button">
  <i
    *ngIf="button.faClassPrefix"
    [style]="button.text ? 'margin-right: 5px;' : ''"
    class="fal"
    [ngClass]="button.faClassPrefix"
  ></i>
  <i
    [ngClass]="button.text ? '' : 'm-0'"
    *ngIf="button.nzTypePrefix"
    nz-icon
    [nzType]="button.nzTypePrefix"
  ></i>
  <ng-content select="[btn-prefix]"></ng-content>
  {{ button.text | translate | titlecase }}
  <i
    *ngIf="button.faClassSuffix"
    [style]="button.text ? 'margin-left: 5px;' : ''"
    class="fal"
    [ngClass]="button.faClassSuffix"
  ></i>
  <i
    [ngClass]="button.text ? '' : 'm-0'"
    *ngIf="button.nzTypeSuffix"
    nz-icon
    [nzType]="button.nzTypeSuffix"
  ></i>

  <ng-content select="[btn-suffix]"></ng-content>
</ng-template>
